import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { Context, RuleInterface } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { AutomationReplacementChipsComponent } from '../../../../../common/components/automation-replacement-chips/automation-replacement-chips.component';
import { UsersSelectorService } from '../../../../../data-services/users-selector-service';
import { TriggerService } from '../../../../trigger.service';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { NoRules } from '../../common';
import {
  adminsAndSalespeople,
  calculateDropdownValueFromJsonData,
  onlyAdmins,
  Options,
  specificUsers,
} from '../manually-trigger-common';
import { WORKFLOW_TRIGGERS } from '../../../../component-loader/trigger-definitions';
import { AutomataContextService } from '@galaxy/automata/shared';

@Component({
  selector: 'automata-manually-trigger-panel',
  templateUrl: './manually-trigger-panel.component.html',
  styleUrls: ['./manually-trigger-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    AutomationReplacementChipsComponent,
  ],
})
export class ManuallyTriggerPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  automationContext = this.automationContextService.currentContext;
  context = Context;

  salesRunnable: boolean;
  usersFormControl: FormControl<string[]> = new FormControl<string[]>([]);
  automationId: string = this.triggerService.automationId;
  userSelectorService = inject(UsersSelectorService);
  options = Options;
  selectedOption: string = onlyAdmins;
  readonly specificUsers = specificUsers;
  nameKey: string;
  descriptionKey: string;

  constructor(
    protected readonly triggerService: TriggerService,
    private readonly automationContextService: AutomataContextService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    //TODO: add extra data for the personas that are listed with the user list
    const triggerDefinitions: { [taskKey: string]: any } = WORKFLOW_TRIGGERS;
    this.nameKey = triggerDefinitions?.[this.taskDefinitionId]?.name;
    this.descriptionKey = triggerDefinitions?.[this.taskDefinitionId]?.nodeDisplay;
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.salesRunnable = !!jsonData.sales_runnable;
    this.usersFormControl.setValue(jsonData?.only_allowed_users?.length > 0 ? jsonData?.only_allowed_users : []);
    this.selectedOption = calculateDropdownValueFromJsonData(this.salesRunnable, this.usersFormControl.value);
    // Nothing to async load so we can enable saving.
    this.savingEnabled$.next(true);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return NoRules();
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }

  getData(): any {
    return {
      sales_runnable: this.selectedOption === adminsAndSalespeople,
      only_allowed_users: this.selectedOption === specificUsers ? this.usersFormControl.value : [],
    };
  }
}
